import { render, staticRenderFns } from "./departure.vue?vue&type=template&id=46c52f7c&scoped=true"
import script from "./departure.vue?vue&type=script&lang=js"
export * from "./departure.vue?vue&type=script&lang=js"
import style0 from "./departure.vue?vue&type=style&index=0&id=46c52f7c&prod&lang=scss"
import style1 from "./departure.vue?vue&type=style&index=1&id=46c52f7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c52f7c",
  null
  
)

export default component.exports